import { useTranslation } from "react-i18next";
import { Price } from "../../../components/__simple/_price";
import { CalendarOutlined, CarOutlined } from "@ant-design/icons";
export function FinanceCar({
    groupColor,
    onApplay,
    offerID,
    productID,
    image,
    modelType,
    name,
    hasOffer,
    brand,
    brandImage,
    brandIcon,
    offerTitle,
    group,
    model,
    brandID,
    price,
    showPric,
    colorName = ""
}) {
    const { t: trans } = useTranslation(["finance", "model", "common", "info"]);
    const isToyota = brand && brand.toLowerCase() === trans("common:toyota").toLowerCase();

    return (
        <div className="vcard" style={{ textAlign: 'center', width: '100%' }}>
            <div className="vimg">
                <img className="lazyload" data-src={image ? image : '/assets/images/car-finance.png'} alt={name} />
                <img
                    alt=""
                    className="vbrand-icon"
                    src={`/assets/icons/brands/${isToyota ? "toyota.svg" : "lexus.svg"}`}
                    style={{ color: isToyota ? "#e60012" : "#1a1a1a" }}
                />
                {colorName && (
                    <div className="vtag">
                        {colorName}
                    </div>
                )}
            </div>

            <div className="vinfo">
                <div>
                    <div className="vbrand-name">{brand}</div>
                    <div className="vt" title={name}>{name}</div>
                    <div className="vspecs">
                        <span>
                            <CalendarOutlined style={{ fontSize: '20px' }} /> {model}
                        </span>

                        {group && (
                            <span>
                                <CarOutlined style={{ fontSize: '20px' }} /> {group}
                            </span>
                        )}
                    </div>
                </div>

                <div className="vprice-action" style={{ textAlign: 'center', width: '100%' }}>
                    {showPric && (
                        <div className="vp" style={{ textAlign: 'center', width: '100%' }}>
                            <Price price={price} style={{ color: '#23cc3f', textAlign: 'center' }} />
                        </div>
                    )}

                    <button className="va" onClick={() => {
                        if (onApplay) {
                            onApplay({
                                productID,
                                offerID,
                                name,
                                price,
                                group,
                                model,
                                brand,
                                brandID,
                                image,
                                brandIcon,
                                brandImage,
                                modelType,
                                groupColor,
                                showPric,
                                colorName,
                            });
                        }
                    }}>
                        {trans("finance:apply")}
                    </button>
                </div>
            </div>
        </div>
    );
}
